import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [banners, setBanners] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch categories
    axios
      .get("https://api.vyapakprint.com/api/category-options")
      .then((res) => {
        const data = res.data.options || res.data || [];
        setCategories(data);
      })
      .catch((err) => console.error(err));

    // Fetch banners
    (async () => {
      try {
        const res = await fetch(
          "https://api.vyapakprint.com/api/banner/getBanners"
        );
        const data = await res.json();
        setBanners(
          Array.isArray(data)
            ? data.sort((a, b) => a.index - b.index)
            : []
        );
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  // ✅ Alphabetical sorting (safe + case insensitive)
  const sortedCategories = useMemo(() => {
    return [...categories].sort((a, b) =>
      (a?.name || "").localeCompare(b?.name || "", undefined, {
        sensitivity: "base",
      })
    );
  }, [categories]);

  const carouselSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Banner Carousel */}
      {banners.length > 0 && (
        <div className="mb-8">
          <Slider {...carouselSettings}>
            {banners.map((banner, index) => (
              <div key={index}>
                <img
                  src={banner.image}
                  alt="banner"
                  className="w-full h-48 sm:h-64 object-cover rounded-2xl"
                />
              </div>
            ))}
          </Slider>
        </div>
      )}

      {/* Section Title */}
      <div className="text-center mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-blue-900 mb-2">
          PRINTING SERVICES
        </h1>
        <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
      </div>

      {/* Category Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {sortedCategories.map((cat) => (
          <div
            key={cat._id}
            onClick={() => navigate(`/products/${cat._id}`)}
            className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100"
          >
            {/* Image */}
            <div className="relative w-full h-48 sm:h-52 md:h-48 lg:h-52 overflow-hidden">
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>

            {/* Content */}
            <div className="p-4">
              <h3 className="text-center text-sm sm:text-base font-semibold text-gray-800 group-hover:text-blue-600 transition-colors duration-300 line-clamp-2">
                {cat.name}
              </h3>
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {sortedCategories.length === 0 && (
        <div className="text-center py-12">
          <div className="text-gray-400 text-xl mb-4">📄</div>
          <h3 className="text-lg font-medium text-gray-600 mb-2">
            No Services Available
          </h3>
          <p className="text-gray-500">
            Please check back later for printing services.
          </p>
        </div>
      )}
    </div>
  );
};

export default CategoryList;